exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2725a735]:export{menu-bgc-oragne:#F2C46D}.spwwFooterPage[data-v-2725a735]{color:#053C80;text-align:center;margin-top:10px;background-color:#F2C46D}.spwwFooterPage .mainCont[data-v-2725a735]{width:1200px;background-color:#F2C46D;padding:6px 0;margin:0 auto;font-family:\"arial-mt\",\"Microsoft YaHei\",Helvetica,Arial,sans-serif}.spwwFooterPage .mainCont.device[data-v-2725a735]{width:900px}.spwwFooterPage .mainCont .footer[data-v-2725a735]{color:#053C80;font-size:12px}.spwwFooterPage .mainCont .footer a[data-v-2725a735]{color:#053C80}\n", ""]);

// exports
